import styled, { css } from 'styled-components';
import { SIDEBAR_MIN_WIDTH, TOP_HEADER_HEIGHT } from '../constants.js';
import { unit, pxToRem } from '../../foundation/spacing/utils.js';
import { themeGet } from '../../foundation/theme/themeGet/get.js';

var InnerContainer = styled.div.withConfig({
  displayName: "InnerContainer",
  componentId: "sc-s0kgya-0"
})(["padding:0 ", " ", ";min-width:", ";background-color:", ";max-height:calc(100vh - ", ");"], unit('md'), unit('2xl'), pxToRem(SIDEBAR_MIN_WIDTH), themeGet('colors.gray.0'), pxToRem(TOP_HEADER_HEIGHT));
var SidebarHeaderWrapper = styled.div.withConfig({
  displayName: "SidebarHeaderWrapper",
  componentId: "sc-s0kgya-1"
})(["background-color:", ";display:flex;flex-direction:row;justify-content:space-between;align-items:center;min-width:", ";height:", ";padding:", " ", ";max-width:100%;position:sticky;top:0;z-index:1;"], themeGet('colors.gray.0'), pxToRem(SIDEBAR_MIN_WIDTH), pxToRem(TOP_HEADER_HEIGHT), unit('lg'), unit('xl'));
var positionRightStyles = css(["border-left:", " solid ", ";"], pxToRem(1), themeGet('colors.border.100'));
var positionLeftStyles = css(["border-right:", " solid ", ";"], pxToRem(1), themeGet('colors.border.100'));
var getPositionStyles = function getPositionStyles(position) {
  if (position === 'left') return positionLeftStyles;
  return positionRightStyles;
};
var Container = styled.aside.withConfig({
  displayName: "Container",
  componentId: "sc-s0kgya-2"
})(["display:flex;flex-direction:column;height:100vh;min-width:", ";max-width:100%;width:max-content;overflow:hidden auto;background-color:", ";", ";"], pxToRem(SIDEBAR_MIN_WIDTH), themeGet('colors.gray.0'), function (_ref) {
  var $position = _ref.$position;
  return getPositionStyles($position);
});

export { Container, InnerContainer, SidebarHeaderWrapper };
